type props = {
    title: string,
    className?: string
}

export default function PageTitle(props:props ) {
    return <div>
        <h2 className={`text-[16px] font-bold pb-1 border-b-main border-b-2 inline-block ${props.className}`}>{props.title}</h2>
    </div>;
}
